import { useState, useCallback, useEffect } from "react";
import cropr from "../../shared/utils/cropr";

export const useForceUpdateOnHashChange = () => {
  // Hack to force react to update when only hashes change
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  useEffect(() => {
    window.onhashchange = () => forceUpdate();
  }, [forceUpdate]);
  return;
};

export const useForceUpdateOnCroprEvent = (eventType: string) => {
  // Force update component when Cropr triggers eventType
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  useEffect(() => {
    cropr.on(eventType, forceUpdate);
  }, [forceUpdate, eventType]);
  return cropr;
};
